export default __webpack_public_path__ + "static/media/logo.cabf8de7.png";